import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { postHasMoreState } from '../../../store/postHasMoreState';
import { postState } from '../../../store/postState';
import { infinitScrollPage } from '../../../store/infinitScrollPage';

export const NewPostForm = (props) => {
  const { init_hospital, staff_user } = props;
  const initialPostState = {
    content: '',
  }
  const [currentPost, setCurrentPost] = useState(initialPostState);
  const [postData, setPostData] = useRecoilState(postState);
  const [hasMoreData, setHasMoreData] = useRecoilState(postHasMoreState);
  const [pageData, setPageData] = useRecoilState(infinitScrollPage);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentPost({
      ...currentPost,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicPostSubmit = () => {
    if (!currentPost.content) {
      alert("※医療機関と投稿内容は必須です。");
      return
    }

    var data = {
      posts: {
        hospital_id: parseInt(init_hospital.id, 10),
        staff_users_id: staff_user,
        content: currentPost.content,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/hospitals/${init_hospital.id}/hospital_posts`, data)
    .then(resp => {
      console.log("New Post 成功");
      console.log(resp.data);
      setPostData(resp.data);
      setPageData(1);
      setHasMoreData(true);
      notify("success", "Post successfully created!");
      setCurrentPost({
        content: '',
      });
    })
    .catch(e => {
      console.log(e.response);
      // alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Post create Error!");
    })
  }

  return (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <div className="row">
            <div className="col">
              <textarea type="text" name="content" className="form-control w-100" id="tweet" rows="3" placeholder="投稿内容" value={currentPost.content} onChange={onChangeData}></textarea>
            </div>
          </div>
        </div>
        <div className="card-footer text-center">
          <button 
            className="btn btn-primary text-white w-75" 
            onClick={onClinicPostSubmit}
            disabled={(!currentPost.content)}
          >
            内容更新
          </button>
        </div>
      </div>
    </>
  );
};